import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SecondMainClient from "components/Client&Partner/2ndMainClient";
import HeroClient from "components/Client&Partner/HeroClient";
import MainClient from "components/Client&Partner/MainClient";
import Missionclient from "components/Client&Partner/Missionclient";
import QuoteClient from "components/Client&Partner/QuoteClient";
import Testimonial from "components/Client&Partner/Testimonial";
import Listnetworks from "components/Client&Partner/ListNetworks";
import AnimationCounter from "components/Homepage/AminationCouter";
import ReadyToGrowCommunity from "components/Client&Partner/ReadyToGrow";

const ClientsandPartner = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");

      setTimeout(() => {
        const element = document.getElementById(id);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, [location]);
  return (
    <div>
      <HeroClient />
      <AnimationCounter />
      <Missionclient />
      <div id="successstories">
        <Testimonial />
      </div>{" "}
      <div id="ourclient">
        <MainClient />
      </div>{" "}
      <div id="networks">
        <Listnetworks />
      </div>{" "}
      <div id="ourpartners">
        <SecondMainClient />
      </div>
      <ReadyToGrowCommunity />
    </div>
  );
};

export default ClientsandPartner;
